import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { routerNavigationAction } from '@ngrx/router-store';
import { Store } from '@ngrx/store';
import { EMPTY, mergeMap, of, switchMap, take } from 'rxjs';
import { GroupType } from '../../models/group.model';
import * as groupActions from '../actions/group.actions';
import { AppState } from '../appstate';
import * as groupSelector from '../selectors/group.selector';
import * as routeSelector from '../selectors/router.selector';

@Injectable()
export class RouterEffects {
  actions$ = inject(Actions);
  router: Router = inject(Router);
  store: Store<AppState> = inject(Store<AppState>);

  constructor() {}

  /**
   * Once a group is loaded to store, check if the current route is to that group, and dispatch the select action
   */
  groupLoadedRouteActions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(groupActions.addOneToStore),
      mergeMap(({ group }) => {
        if (!group) return EMPTY;

        return this.store.select(routeSelector.selectRouteParams).pipe(
          take(1),
          switchMap((params: any) => {
            const id = params['id'];
            if (group.id === id) {
              return of(
                groupActions.select({
                  source: `RouterEffects :: groupLoadedRouteActions$ : ${group.groupType} : ${group.id}`,
                  groupType: group.groupType ?? GroupType.church,
                  groupId: group.id,
                })
              );
            } else {
              return EMPTY;
              // return of(groupActions.unselect());
            }
          })
        );
      })
    )
  );

  // Effect to handle the router navigation start to a group, and dispatch the select action
  groupRouteEvent$ = createEffect(() =>
    this.actions$.pipe(
      ofType(routerNavigationAction),
      switchMap((event) => {
        // console.log(
        //   `RouterEffects :: groupRouteEvent$: event.url: ${event.payload.event.urlAfterRedirects}`
        // );
        const urlSegments = event.payload.event.urlAfterRedirects.split('/');
        const groupIdIndex = urlSegments.indexOf('groups') + 1;
        const groupId = urlSegments[groupIdIndex];
        const schoolIdIndex = urlSegments.indexOf('school') + 1;
        const schoolId = urlSegments[schoolIdIndex];
        if (groupId) {
          return this.store.select(groupSelector.selectedGroupId).pipe(
            take(1),
            switchMap((currGroupId) => {
              if (currGroupId !== groupId) {
                return of(
                  groupActions.select({
                    source: `RouterEffects :: groupRouteEvent$ : groupId: ${groupId}`,
                    groupType: GroupType.church,
                    groupId,
                  })
                );
              } else {
                return EMPTY;
              }
            })
          );
        } else if (schoolId) {
          return this.store.select(groupSelector.selectedGroupId).pipe(
            take(1),
            switchMap((currGroupId) => {
              if (currGroupId !== schoolId) {
                return of(
                  groupActions.select({
                    source: `RouterEffects :: groupRouteEvent$ : schoolId: ${schoolId}`,
                    groupType: GroupType.school,
                    groupId: schoolId,
                  })
                );
              } else {
                return EMPTY;
              }
            })
          );
        } else return of(groupActions.unselect());
      })
    )
  );
}
